function updateVariantElements(variantId) {
  // Hide all titles and SKUs
  document.querySelectorAll('.variant-title, .variant-sku').forEach(el => {
    el.style.display = 'none';
  });

  // Show the matching variant ones (can be multiple - main product + sticky)
  const matchedTitles = document.querySelectorAll(`.variant-title[data-variant-id="${variantId}"]`);
  const matchedSkus = document.querySelectorAll(`.variant-sku[data-variant-id="${variantId}"]`);
  
  if (matchedTitles.length > 0) {
    matchedTitles.forEach(el => {
      el.style.display = 'inline';
    });
  } else {
    // Show all fallback titles if no specific variant match
    const fallbackTitles = document.querySelectorAll('.variant-title[data-variant-id="fallback"]');
    fallbackTitles.forEach(el => {
      el.style.display = 'inline';
    });
  }
  
  if (matchedSkus.length > 0) {
    matchedSkus.forEach(el => {
      el.style.display = 'inline';
    });
  } else {
    // Show all fallback SKUs if no specific variant match
    const fallbackSkus = document.querySelectorAll('.variant-sku[data-variant-id="fallback"]');
    fallbackSkus.forEach(el => {
      el.style.display = 'inline';
    });
  }
}

// Get initial variant ID (URL param first, then form input, then first variant)
function getCurrentVariantId() {
  const urlParams = new URLSearchParams(window.location.search);
  let variantId = urlParams.get('variant');

  if (!variantId) {
    const variantInput = document.querySelector('select[name="id"], input[name="id"]');
    variantId = variantInput ? variantInput.value : null;
    if (!variantId) {
      // Get from variants JSON
      const variantsScript = document.querySelector('variant-selects script[type="application/json"]');
      if (variantsScript) {
        const variants = JSON.parse(variantsScript.textContent);
        variantId = variants.length > 0 ? variants[0].id : null;
      }
    }
  }

  return variantId;
}

// Run immediately to show initial state
const initialVariantId = getCurrentVariantId();
if (initialVariantId) {
  updateVariantElements(initialVariantId);
} else {
  // Safety: if no variant ID found, show all fallbacks
  document.querySelectorAll('.variant-title[data-variant-id="fallback"], .variant-sku[data-variant-id="fallback"]').forEach(el => {
    el.style.display = 'inline';
  });
}

// Also run after a short delay to ensure variant-selects has initialized
setTimeout(() => {
  const delayedVariantId = getCurrentVariantId();
  if (delayedVariantId) {
    updateVariantElements(delayedVariantId);
  }
}, 100);

// Listen for variant changes
document.addEventListener('DOMContentLoaded', () => {
  const variantInput = document.querySelector('select[name="id"], input[name="id"]');
  if (variantInput) {
    variantInput.addEventListener('change', (e) => {
      updateVariantElements(e.target.value);
    });
  }
});
